/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESApplyForBenefits' store object.
 * @namespace ACESApplyForBenefitsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESApplyForBenefits';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESApplyForBenefitsSelectors
   */
  static fetchAcesOnlineCategoriesChap3 = state =>
    state[selectors.moduleIdentifier].fetchAcesOnlineCategoriesChap3.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESApplyForBenefitsSelectors
   */
  static isFetchingFetchAcesOnlineCategoriesChap3 = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesOnlineCategoriesChap3.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESApplyForBenefitsSelectors
   */
  static fetchAcesOnlineCategoriesChap3Error = state =>
    state[selectors.moduleIdentifier].fetchAcesOnlineCategoriesChap3Error.payload;
}
